'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiPipette = function TiPipette(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.6 12.2c0.2-2-0.6-4-1.9-5.3-1.2-1.2-3-1.9-4.8-1.9-2 0-3.7 0.8-4.7 2.1-1.2 1.4-2.4 4.3-3 6.1l-2.7-2.7c-0.6-0.7-1.7-0.7-2.3 0-0.7 0.6-0.7 1.7 0 2.3l0.5 0.5-8.8 8.7c-0.6 0.6-1.2 1.5-1.6 2.5 0 0.1-2.8 7.3-0.1 10 0.9 0.9 2.2 1.2 3.6 1.2 3 0 6.3-1.4 6.3-1.4 1-0.4 1.9-1 2.5-1.6l8.8-8.7 0.4 0.5c0.4 0.3 0.8 0.5 1.2 0.5s0.9-0.2 1.2-0.5c0.6-0.7 0.6-1.7 0-2.4l-2.7-2.7c1.7-0.6 4.6-1.8 6.1-2.9 1.2-1 1.9-2.5 2-4.3z m-27.1 19.9c-0.4-0.5-0.1-2.5 0.3-4.3l4 4.1c-1.8 0.4-3.8 0.6-4.3 0.2z m7.8-1.7c-0.3 0.3-0.9 0.6-1.5 0.8 0 0.1-0.1 0.1-0.2 0.1l-5.3-5.3c0.1 0 0.1-0.1 0.1-0.2 0.3-0.6 0.6-1.1 0.9-1.4l8.7-8.7 6 5.9-8.7 8.8z' })
        )
    );
};

exports.default = TiPipette;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/pipette.js
// module id = 3921
// module chunks = 0